export const getCategoryLocation = (location) => {
  const categoryName = location.replace('category-', '');
  const firstLetter = categoryName.charAt(0).toUpperCase();
  const restWord = categoryName.slice(1);
  return `${firstLetter}${restWord}`;
};

export const wordToUppercase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const replaceBreaks = (str) => {
  return str.split('\r\n\r\n').map(item => `<p>${item.replace('\r\n', '<br />')}</p>`).join('');
};

export const isBrowser = typeof window !== 'undefined';
